import { motion } from "framer-motion";
import { useRef, useState, useEffect } from "react";
import { useAnimation } from "framer-motion";
import { Player } from "lottie-react";
import { useNavigate } from "react-router-dom";
import LoadingOverlay from "../../shared/LoadingOverlay";
import InformationModal from "../../shared/InformationModal";
import heroImage from "../../assets/images/hero-image-12.jpg";


export default function TrainingForm() {
const formRef = useRef(null);
const controls = useAnimation();
const navigate = useNavigate();

const [form, setForm] = useState({
  full_name: "",
  email: "",
  address: "",
  experience_level: "",
  motivation: "",
});

  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(null);
const [errors, setErrors] = useState({});

const [toast, setToast] = useState(null);
const [showModal, setShowModal] = useState(false);
const [lottieData, setLottieData] = useState(null);

  const closeModal = () => {
    setShowModal(false);
    navigate("/");
  };

const handleChange = (e) => {
  setForm((prev) => ({
    ...prev,
    [e.target.name]: e.target.value,
  }));

  setErrors((err) => ({
    ...err,
    [e.target.name]: undefined,
  }));
};


const handleSubmit = async (e) => {
  e.preventDefault();
  setToast(null);

  if (!validate()) {
    controls.start({
      x: [0, -8, 8, -6, 6, -3, 3, 0],
      transition: { duration: 0.6, ease: "easeInOut" },
    });
    setToast({ type: "error", text: "Please fix the errors." });
    return;
  }

  setLoading(true);

  try {
    const res = await fetch(`${API_BASE}/training-application`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(form),
    });

    const data = await res.json();
    setLoading(false);

    if (res.ok && data.success !== false) {
      setForm({
        full_name: "",
        email: "",
        address: "",
        experience_level: "",
        motivation: "",
      });
      setErrors({});
      setShowModal(true);
    } else {
      throw new Error();
    }
  } catch {
    setLoading(false);
    setToast({ type: "error", text: "Submission failed. Try again later." });
  }
};

  useEffect(() => {
  fetch("/assets/lottie/success.json")
    .then((r) => (r.ok ? r.json() : Promise.reject()))
    .then(setLottieData)
    .catch(() => setLottieData(null));
}, []);

useEffect(() => {
  if (!toast) return;
  const t = setTimeout(() => setToast(null), 3500);
  return () => clearTimeout(t);
}, [toast]);

const validate = () => {
  const e = {};
  if (!form.full_name.trim()) e.full_name = true;
  if (!form.email.trim()) e.email = true;
  if (!form.address.trim()) e.address = true;
  if (!form.experience_level) e.experience_level = true;
  if (!form.motivation.trim()) e.motivation = true;

  setErrors(e);
  return Object.keys(e).length === 0;
};



  const API_BASE =
  process.env.REACT_APP_API_BASE_URL || "http://127.0.0.1:8000/api";

  const isFormValid =
  form.full_name.trim() !== "" &&
  form.email.trim() !== "" &&
  form.address.trim() !== "" &&
  form.experience_level !== "" &&
  form.motivation.trim() !== "" &&
  !loading;

  console.log("API BASE:", API_BASE);
  return (
    
    <section className="relative w-full overflow-hidden">
      {/* ===== ANIMATED BACKGROUND IMAGE ===== */}
      <motion.div
        className="absolute inset-0 bg-cover bg-center"
        // style={{ backgroundImage: `url(${heroImage})` }}
        // initial={{ scale: 1.05, y: 0 }}
        // animate={{ scale: 1.15, y: -40 }}
        // transition={{
        //   duration: 18,
        //   repeat: Infinity,
        //   repeatType: "reverse",
        //   ease: "easeInOut",
        // }}
      />

      {/* ===== OVERLAY ===== */}
      <div className="absolute inset-0 bg-[#05060a]/40 backdrop-blur-sm" />

      {/* ===== CONTENT (WIDER CONTAINER) ===== */}
      <div className="relative z-10 mx-auto max-w-[1400px] py-20 px-6 md:px-12 lg:px-16">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-[clamp(2rem,6vw,5rem)] items-center">

          {/* ================= LEFT CONTENT (RESTORED) ================= */}
          <div className="lg:col-span-2 space-y-8 text-center lg:text-left">
            <motion.h2
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
              className="
                text-[clamp(2.6rem,6vw,5rem)]
                font-semibold
                tracking-tight
                text-white
              "
            >
              Let’s Join
            </motion.h2>

            <p className="mx-auto lg:mx-0 max-w-md text-lg text-white/70 leading-relaxed">
              The{" "}
              <span className="text-white font-medium">
                BroadBoy Climbing Academy (BBCA)
              </span>{" "}
              is a seven-day intensive training program designed to build a new
              generation of disciplined, skilled, and safety-focused Pakistani
              climbers and high-altitude porters.
            </p>

            <div className="space-y-6 pt-6 border-t border-gray-500 max-w-md mx-auto lg:mx-0">
              <div>
                <p className="font-medium text-white text-sm">Who can apply?</p>
                <p className="text-white/60 text-sm">
                  Young climbers and local porters (ages 15–30) with basic
                  mountain exposure, strong discipline, and passion to grow.
                </p>
              </div>

              <div>
                <p className="font-medium text-white text-sm">
                  What happens next?
                </p>
                <p className="text-white/60 text-sm">
                  Shortlisted applicants will be contacted for interviews and
                  final selection into the academy.
                </p>
              </div>
            </div>
          </div>

          {/* ================= RIGHT FORM (WIDER) ================= */}
          <motion.div
            animate={controls}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.1 }}
            className="lg:col-span-3 bg-gray-400/15 backdrop-blur-3xl p-10 rounded-3xl shadow-xl w-full"
          >
  
            <form ref={formRef} onSubmit={handleSubmit} className="space-y-8">
              <h3 className="text-2xl font-semibold text-white">
                Apply to Join{" "}
                <span className="text-white/60">the Program</span>
              </h3>

              {/* ===== TWO COLUMN GRID ===== */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                  <label className="block text-sm font-medium text-white mb-2">
                    Full Name*
                  </label>
                  <input
                    type="text"
                    name="full_name"
                    value={form.full_name}
                    onChange={handleChange}
                    required
                    placeholder="Your full name"
                    className="w-full rounded-xl bg-white/10 px-4 py-3 text-white placeholder-white/10 outline-none focus:ring-2 focus:ring-white/20"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-white mb-2">
                    E-mail*
                  </label>
                  <input
                    type="email"
                    name="email"
                    value={form.email}
                    onChange={handleChange}
                    required
                    placeholder="username@domain.com"
                    className="w-full rounded-xl bg-white/10 px-4 py-3 text-white placeholder-white/10 outline-none focus:ring-2 focus:ring-white/20"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-white mb-2">
                    Address*
                  </label>
                  <input
                    type="text"
                    name="address"
                    value={form.address}
                    onChange={handleChange}
                    required
                    placeholder="City, District, Province"
                    className="w-full rounded-xl bg-white/10 px-4 py-3 text-white placeholder-white/10 outline-none focus:ring-2 focus:ring-white/20"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-white mb-2">
                    Past Experience Level*
                  </label>

                  <div className="relative">
                    <select
                      required
                      name="experience_level"
                      value={form.experience_level}
                      onChange={handleChange}
                      className="
                        w-full
                        appearance-none
                        rounded-xl
                        bg-white/10
                        px-4 py-3 pr-12
                        text-white
                        outline-none
                        focus:ring-2 focus:ring-white/10
                        cursor-pointer
                        [&>option]:bg-[#17283b]
                        [&>option]:text-white
                      "
                    >
                      <option value="" disabled className="text-white/60">
                        Select experience level
                      </option>
                      <option value="beginner">Beginner</option>
                      <option value="amateur">Amateur</option>
                      <option value="professional">Professional</option>
                    </select>

                    <div className="pointer-events-none absolute inset-y-0 right-4 flex items-center">
                      <svg
                        className="w-5 h-5 text-white/70"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M19 9l-7 7-7-7"
                        />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>

              {/* ===== FULL WIDTH MESSAGE ===== */}
              <div>
                <label className="block text-sm font-medium text-white mb-2">
                  Why do you want to join BBCA?
                </label>
                <textarea
                  name="motivation"
                  value={form.motivation}
                  onChange={handleChange}
                  rows={5}
                  placeholder="Tell us about your background and motivation…"
                  className="w-full rounded-xl bg-white/20 px-4 py-3 text-white placeholder-white/60 outline-none resize-none focus:ring-2 focus:ring-white/20"
                />
              </div>

              {/* Submit */}

              <button
                disabled={!isFormValid}
                type="submit"
                className={`w-full rounded-full  py-4 text-gray-800 font-medium transition
                   ${
                  isFormValid
                    ? "bg-gray-300 hover:bg-white  cursor-pointer"
                    : "bg-gray-200/20 cursor-not-allowed opacity-50"
                }  `}
          
              >
              {loading ? "Submitting..." : "Submit Application"}
              </button>
            </form>
              {toast?.type === "error" && (
              <div className="fixed bottom-6 right-6 px-6 py-3 rounded-xl shadow-lg z-50 bg-red-600 text-white">
                {toast.text}
              </div>
            )}

          </motion.div>
        </div>
      </div>
         <LoadingOverlay show={loading} />
      <InformationModal
             show={showModal}
             lottieData={lottieData}
             title="Message Sent Successfully!"
             onClose={closeModal}
           />
    </section>
    
  );
}